import project1_1 from "../images/recruiting hire 01.jpg";
import project2_1 from "../images/fortuino1.png";
import project3_1 from "../images/perfumeProject.png";
import project4_1 from "../images/rock-paper1.png";
import project5_1 from "../images/sheikhMujib1.png";
import project1_2 from "../images/recruiting hire 02.jpg";
import project2_2 from "../images/fortuino2.png";
import project3_2 from "../images/perfumeProject2.png";
import project4_2 from "../images/rock-paper2.png";
import project5_2 from "../images/sheikhMujib2.png";
import project1_3 from "../images/recruiting hire 03.jpg";
import project2_3 from "../images/fortuino3.png";
import project3_3 from "../images/perfumeProject3.png";
import project4_3 from "../images/rock-paper3.png";
import project5_3 from "../images/sheikhMujib3.png";
import { useEffect, useState } from "react";

const projects = [
  {
    id: 1,
    name: "Recruiting Hire",
    desc: "A fullstack redux based web platform for recruiting and job searching",
    image1: project1_1,
    image2: project1_2,
    image3: project1_3,
    liveSite: "https://recruiting-hire.web.app/",
    clientCode: "https://github.com/mdsaharshital/Recruiting-Hire-client",
    serverCode: "https://github.com/mdsaharshital/recruiting-hire-server",
    logndesc: `Redux-toolkit based platform for recruiting and job searching is a comprehensive solution for both employers and job seekers. The platform was designed to provide a simple and efficient way for users to register as employers or candidates, post and apply for jobs. The platform includes real-time chat functionality to allow employers and candidates to communicate directly with each other. Additionally, a comment section is available to answer any queries related to job postings.

To ensure the privacy and security of the users, user authentication and authorization features were implemented. This means that employers can create job openings and view candidate information and applications while candidates can view and track their applied jobs. The platform incorporates a dashboard that provides an overview of all job openings and applications, making it easy for employers to manage job openings and communicate with candidates. Candidates can view and track their job applications and receive notifications when new job openings become available.

The platform is user-friendly and provides a seamless experience for employers and job seekers alike. The real-time chat functionality and comment section allow for direct communication between employers and candidates, making it easier to connect and discuss potential job opportunities. With its user authentication and authorization features and dashboard, the platform ensures that employers and candidates have access to all the information they need to make informed decisions. Overall, the web-based platform for recruiting and job searching provides an efficient and effective solution for those seeking to fill job openings or find employment. Additional features and technologies are described below:`,
    features: [
      "Job Posting: Employers can post job openings with relevant details.",
      "Job Application: Candidates can search and apply for jobs.",
      "Real-Time Chat: Employers and candidates can communicate directly.",
      "Comment Section: Employers can answer queries related to job postings.",
      "User Authentication and Authorization: Secure access for employers and candidates.",
      "Dashboard: Candidates can track applied jobs, employers can manage job openings.",
      "User Registration: Users can register as employers or candidates.",
    ],
    frontend: [
      "React JS",
      "Redux-Toolkit",
      "React Router",
      "React Query",
      "Firebase Authentication",
      "React tailwind CSS",
      "Daisy UI",
      "React Firebase Hook",
      "React hook form",
    ],
    backend: [
      "Node js",
      "Express Js",
      "MongoDB",
      "CORS",
      "Dotenv",
      "jsonwebtoken",
    ],
  },
  {
    id: 2,
    name: "Fortuino Manufacturer",
    desc: "A fullStack project for a wood manufacturer who sells their woods and furniture to small or big businesses.",
    image1: project2_1,
    image2: project2_2,
    image3: project2_3,
    liveSite: "https://fortunio-timber.web.app/",
    clientCode: "https://github.com/mdsaharshital/wood-manufacturer-client",
    serverCode: "https://github.com/mdsaharshital/wood-manufacturer-server",
    logndesc: `This website is for a furniture company that sells wood to small and large organizations. They mostly utilize this website to display and sell their items to clients. They (administrators) have the ability to handle items, users, and orders. When they deliver it to the consumer who paid for it, the customer can then provide a product review based on their experience with it. The stripe method makes it simple to pay. There are additional sections that best describe the website in the review product ad. Additional features and technologies are described below:
         `,
    features: [
      "Payment Integration with Stripe",
      "Google Sign In",
      "Dashboard for Admin Only",
      "Managing a Product to Database",
      "Managing Users and Their Orders",
      "Admin Role and Normal User",
      "Profile Section that Updates with Database",
      "Review Products Only for Paid and Delivered Products",
    ],
    frontend: [
      "React JS",
      "React Router",
      "React Query",
      "Firebase Authentication",
      "React Tailwind CSS",
      "Daisy UI",
      "React Firebase Hook",
      "React Hook Form",
    ],
    backend: [
      "MongoDB",
      "Node.js",
      "Express.js",
      "CORS",
      "Dotenv",
      "jsonwebtoken",
      "Stripe",
    ],
  },
  {
    id: 3,
    name: "Perfume Warehouse",
    desc: "A fullStack inventory management system where an owner and his co-workers can easily manage their products.",
    image1: project3_1,
    image2: project3_2,
    image3: project3_3,
    liveSite: "https://perfume-warehouse-17111.web.app/",

    clientCode:
      "https://github.com/mdsaharshital/perfume-warehouse-management-system-client",
    serverCode:
      "https://github.com/mdsaharshital/perfume-warehouse-management-system-server",
    logndesc: `This is a full-stack inventory management system that allows a business owner and his employees to simply manage their items. They have the ability to both add and remove goods. When users log in, they may control their whole inventory. There are several private as well as public routes in this list. The MERN Stack is utilized in this complete stack project, and the technologies involved are listed below:`,
    features: [
      "Automatic logout for unauthorized token",
      "Add and remove product by authenticated user",
      "Private route",
      "Conditional header menus",
      "Sign in and sign up feature using Firebase",
      "Single-page app using React Router DOM",
      "Authentication using JSON Web Token (JWT)",
      "Responsive design for mobile, tablet, and laptop",
    ],
    frontend: [
      "React",
      "React Query",
      "React DOM",
      "Firebase",
      "React Firebase Hooks",
      "React Icons",
    ],
    backend: ["Node.js", "Express.js", "MongoDB", "JSON Web Token (JWT)"],
  },
  {
    id: 4,
    name: "Rock paper scissor",
    desc: "This is the most famous game rock paper scissors. Fully developed by own logic in React js.",
    image1: project4_1,
    image2: project4_2,
    image3: project4_3,
    logndesc: `Rock, paper, scissors is a well-known game. I'm assuming you're all familiar with the rules. If not, go to the live site and look for a button labeled rules that will show you the regulations. Every time you click "Go," it will choose one of the remaining alternatives at random. You will lose one point if you lose, and you will gain one point if you win. There will be no point increase or drop if you draw. It is enjoyable to play in one's spare time. I hope you find it entertaining. Thank you very much!`,
    liveSite: "https://rock-paper-scissior-by-shital.netlify.app/",
    clientCode: "https://github.com/mdsaharshital/rock-paper-scissors",
    features: [
      "Familiar rules: Players are assumed to be familiar with the rules of the game.",
      "Rules button: Provides access to the regulations for those who are not familiar with the game.",
      "Random selection: Each time the 'Go' button is clicked, one of the remaining options is chosen randomly.",
      "Scoring system: Players gain one point for winning and lose one point for losing.",
      "Draws: No point increase or decrease occurs in the event of a draw.",
      "Enjoyable gameplay: Provides entertainment during leisure time.",
    ],
    frontend: ["React.Js", "TailWind CSS", "Daisyui", "React Router Dom"],
  },
  {
    id: 5,
    name: "Wildlife photographer",
    desc: "This is a frontend project for a photographer who wants to showcase his photography to the world",
    image1: project5_1,
    image2: project5_2,
    image3: project5_3,
    liveSite: "https://sheikh-mujib-photographer.netlify.app/",
    clientCode: "https://github.com/mdsaharshital/wild-photographer-react-auth",
    logndesc: `This is the website of Sheik Mujib, a well-known photographer. He is a wildlife photographer who also sells his work on the NFT market. This website includes a lot of features. Only logged-in users have the ability to purchase his displays. The following technologies were used:`,
    features: [
      "This is a Single Page Application (SPA)",
      "Responsive navbars",
      "Firebase authentication",
      "Sign in with Google, GitHub, and email/password",
      "Email verification",
      "React Router for routing",
      "Private routing",
      "Active route",
    ],
    frontend: [
      "React",
      "Firebase",
      "React Bootstrap",
      "React DOM",
      "React Firebase Hooks",
      "React Icons",
      "React Router DOM",
      "React Toastify",
    ],
  },
];
const useProjectDetails = (id) => {
  const [project, setProject] = useState([]);

  useEffect(() => {
    const newData = projects.filter((s) => s.id === parseInt(id));
    setProject(...newData);
  }, [id]);
  return [project];
};

export default useProjectDetails;
